/** Ошибка загрузки «Голоса клиента» (#848) с повтором — одна на все вкладки и блоки. */
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

/** The section's load error with a retry. */
export function VoiceLoadError({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation(['dashboard', 'common']);
  return (
    <div className="py-8 text-center text-sm text-fg-muted">
      <p>{t('voicePage.error')}</p>
      <Button variant="ghost" size="sm" onClick={onRetry}>
        {t('common:retry')}
      </Button>
    </div>
  );
}
